<template>
  <div class="login-container">
    <!-- 头部标题区域 -->
    <div class="header-section">
      <h1 class="main-title">万能快查数据发布平台</h1>
      <p class="subtitle">快速发布 · 简单查询</p>
    </div>

    <!-- 主内容区域 -->
    <div class="content-section">
      <!-- 左侧图片区域 -->
      <div class="left-panel">
        <div class="image-wrapper">
          <img src="/wansearch/hompage_images/p1.png" alt="平台展示" class="platform-image" />
        </div>
      </div>

      <!-- 右侧登录卡片区域 -->
      <div class="right-panel">
        <el-card class="login-card" shadow="hover">
          <div slot="header" class="card-header">
            <span class="card-title">万能快查扫码登录</span>
          </div>

          <div class="login-content">
            <!-- 扫码按钮 -->
            <div class="scan-section">
              <el-button
                class="scan-btn"
                type="warning"
                @click="scanLogin()"
                icon="el-icon-scan">
                点我打开登录窗口
              </el-button>
            </div>

            <!-- 登录步骤 -->
            <div class="steps-section">
              <div class="steps-title">登录步骤</div>
              <div class="steps-list">
                <div class="step-item">
                  <span class="step-number">1</span>
                  <span class="step-text">点击上面按钮会弹出显示方形二维码的窗口</span>
                </div>
                <div class="step-item">
                  <span class="step-number">2</span>
                  <span class="step-text">打开万能快查小程序，点"如何使用"页面上的"扫码登录电脑端"扫方形二维码登录</span>
                </div>
              </div>
            </div>

            <!-- 帮助按钮 -->
            <div class="help-section">
              <el-button
                @click="howToSwitch"
                type="text"
                size="medium"
                class="help-btn">
                <i class="el-icon-question"></i>
                扫码失败怎么办？请切换浏览器模式
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 底部备案信息 -->
    <div class="footer-section">
      <div class="footer-content">
        <span class="footer-item">智韬科技</span>
        <span class="footer-item">
          ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank" class="footer-link">陇ICP备19004729号-3</a>
        </span>
        <span class="footer-item">
          <img src="https://www.51tianbiao.com/form/images/gongan_beian_logo.png" class="beian-icon" alt="公网安备" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62010202004355" rel="noreferrer" target="_blank" class="footer-link">
            甘公网安备62010202004355号
          </a>
        </span>
      </div>
    </div>

    <!-- 模式切换帮助对话框 -->
    <el-dialog
      width="80%"
      :close-on-click-modal="false"
      title="如何切换浏览器的模式"
      :visible.sync="browserSwitchDialogVisible"
      class="browser-dialog">
      <div class="dialog-content">
        <p class="dialog-text">如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"</p>
        <div class="dialog-image">
          <img src="../assets/switch_browser.png" alt="切换浏览器模式" />
        </div>
        <p class="dialog-text dialog-text-highlight">正确的应该是如下图所示：</p>
        <div class="dialog-image">
          <img src="../assets/good_browser.png" alt="正确的浏览器模式" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 扫码登录对话框 -->
    <el-dialog
      width="60%"
      :close-on-click-modal="false"
      title="扫码登录(手机端小程序功能更丰富,请尽量用手机端)"
      :visible.sync="scanLoginDialogVisible"
      :before-close="beforeClose"
      class="scan-dialog">
      <div class="scan-dialog-content">
        <div class="scan-step">
          <div class="scan-step-title">第一步：用微信打开"万能快查"</div>
          <div class="scan-qrcode">
            <img src="/wansearch/images/wansearch_qrcode.jpg" alt="万能快查二维码" />
          </div>
        </div>

        <div class="scan-instructions">
          <p class="instruction-text">
            用<span class="highlight-text">万能快查微信小程序</span>
            <span class="bold-text">"更多功能"</span>中的<span class="bold-text">"扫码登录电脑端"</span>扫右侧的二维码登录。
          </p>
          <p class="warning-text">
            <i class="el-icon-warning"></i>
            如果扫码后无法登录：1.检查浏览器是否是“高速模式”；2.更换浏览器或清空浏览器缓存(清空浏览记录)。
          </p>
          <div class="help-link">
            <el-button @click="howToSwitch" type="text" size="medium">
              <i class="el-icon-question"></i>
              如何将浏览器切换成"高速模式"或"极速模式"
            </el-button>
          </div>
        </div>

        <div class="scan-step">
          <div class="scan-step-title">第二步：用万能快查"扫码登录"</div>
          <div class="scan-qrcode">
            <img :src="login_qrcode_url" alt="登录二维码" />
          </div>
        </div>
      </div>



      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeScan">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 测试登录对话框 -->
    <el-dialog
      width="30%"
      :close-on-click-modal="false"
      title="测试登录"
      :visible.sync="testDialogVisible"
      :before-close="beforeClose"
      class="test-dialog">
      <div class="test-dialog-content">
        <el-form :model="loginForm" status-icon ref="loginForm" label-width="100px" class="login-form">
          <el-form-item label="手机号" prop="username">
            <el-input type="text" v-model="loginForm.username" autocomplete="off" placeholder="输入手机号,和手机端相同">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')"
              autocomplete="off" placeholder="输入密码,和手机端相同"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="dialog-footer-buttons">
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          <el-button @click="cancelTestLogin">取消</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      browserSwitchDialogVisible: false,
      loginForm: {
        username: '',
        password: '',
        qrcode_url: '/wansearch/web/_qrcode.jsp'
      },

      images: [
        '/wansearch/hompage_images/p1.png'
      ],

      scanLoginDialogVisible: false,
      timer: null,

      scanDownloadDialogVisible: false,
      showDownloadLink: false,
      download_file_url: '',
      login_qrcode_url: '/wansearch/web/_qrcode.jsp',
      download_qrcode_url: '/wansearch/web/_download_qrcode.jsp',

      testDialogVisible: false
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  created() {
    this.$session.set('USERNAME', '') // 存session
    this.$session.set('NAME', '') // 存session
  },
  methods: {
    submitForm(formName) {
      let that = this

      if (this.loginForm.username === '') {
        that.$message.error('请输入手机号')
        return
      }

      if (this.loginForm.password === '') {
        that.$message.error('请输入密码')
        return
      }

      // 开启loading
      const load = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      var requestUrl = '/wansearch/web/_login.jsp'

      this.axios.get(requestUrl, {
          params: {
            username: that.loginForm.username,
            password: that.loginForm.password
          }
        }).then(function(response) {
          console.log(response.data.result)
          var result = response.data.result
          if (result === '0') {
            that.$session.set('USERNAME', that.loginForm.username) // 存session
            that.$session.set('NAME', response.data.name) // 存session

            // that.$router.push('/exam_list')

            that.$router.push({
              path: '/query_list',
              params: {
                username: that.loginForm.username
              }
            })
          } else {
            var tip = response.data.password_tip
            if (tip === '') {
              that.$message.error('账号错误,登录失败！')
            } else {
              that.$message.error('密码错误,登录失败！密码提示:' + tip)
            }
          }

          load.close()
        })
        .catch(err => {
          that.$message.error('登录失败，网络异常请稍后重试！')
          console.log(err)
          load.close()
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    registe() {
      this.$router.push('/registe')
    },
    howToSwitch() {
      this.browserSwitchDialogVisible = true
    },
    enterFun() {

      // this.submitForm('loginForm')
    },
    forgotPassword() {
      this.$message.error('请用手机端多人填表小程序查看密码!')
    },
    scanLogin() {
      let that = this

      var timestamp = new Date().getTime()

      this.login_qrcode_url = this.login_qrcode_url + '?t=' + timestamp



      this.timer = setInterval(function() {
        // console.log(this.timer)


        // 执行内容this.timer
        var requestUrl = '/wansearch/web/_query_login_state.jsp'

        that.axios.get(requestUrl, {
          params: {}
        }).then(function(res) {

          var usr = res.data.username


          if (res.data.result === '1') {
            that.$session.set('USERNAME', usr)
            clearInterval(that.timer)

            that.$router.push({
              path: '/query_list',
              params: {
                username: usr
              }
            })
          } else {}
        })
      }, 1000)
      this.scanLoginDialogVisible = true
    },
    closeScan() {
      clearInterval(this.timer)
      this.scanLoginDialogVisible = false
    },
    beforeClose() {
      this.closeScan()
    },
    scanDownload() {
      let that = this

      var timestamp = new Date().getTime()

      this.download_qrcode_url = this.download_qrcode_url + '?t=' + timestamp

      this.timer = setInterval(function() {
        // console.log(this.timer)

        // 执行内容this.timer
        var requestUrl = '/wansearch/web/_query_download_state.jsp'

        that.axios.get(requestUrl, {
          params: {}
        }).then(function(res) {
          if (res.data.result === '1') {
            var download_file_url = res.data.download_file_url
            clearInterval(that.timer)

            that.download_file_url = download_file_url

            this.$message.success('文件已经传输成功，请点下载文件按钮下载！')

            console.log(download_file_url)

            // that.$router.push({
            //   path: '/download_file',
            //   params: {
            //     username: usr
            //   }
            // })
          } else {}
        })
      }, 1000)
      this.download_file_url = ''
      this.scanDownloadDialogVisible = true
    },
    closeDownload() {
      clearInterval(this.timer)
      this.scanDownloadDialogVisible = false
    },
    downloadFile() {
      window.open(this.download_file_url)
    },
    testLogin() {
      console.log('*******')
      this.testDialogVisible = true
    },
    cancelTestLogin() {
      this.testDialogVisible = false
    }

  }
}
</script>

<style scoped>
/* ==================== 页面整体容器 ==================== */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}

/* ==================== 头部区域 ==================== */
.header-section {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 50px;
  animation: fadeInDown 0.8s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.main-title {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  letter-spacing: 2px;
}

.subtitle {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  margin: 16px 0 0 0;
  font-weight: 400;
  letter-spacing: 3px;
}

/* ==================== 主内容区域 ==================== */
.content-section {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 60px;
  width: 100%;
  max-width: 1400px;
  margin-bottom: 80px;
  animation: fadeInUp 0.8s ease-out 0.2s backwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ==================== 左侧图片区域 ==================== */
.left-panel {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 600px;
}

.image-wrapper {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.platform-image {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* ==================== 右侧登录卡片区域 ==================== */
.right-panel {
  flex: 0 0 500px;
}

.login-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.login-card:hover {
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
}

.card-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: -20px -20px 20px -20px;
  border-radius: 16px 16px 0 0;
}

.card-title {
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 1px;
}

/* ==================== 登录内容区域 ==================== */
.login-content {
  padding: 20px 10px;
}

/* 扫码按钮区域 */
.scan-section {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.scan-btn {
  font-size: 18px;
  font-weight: 500;
  padding: 16px 40px;
  border-radius: 30px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border: none;
  box-shadow: 0 8px 20px rgba(245, 87, 108, 0.3);
  transition: all 0.3s ease;
}

.scan-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(245, 87, 108, 0.4);
}

.scan-btn:active {
  transform: translateY(0);
}

/* 登录步骤区域 */
.steps-section {
  margin-bottom: 30px;
  padding: 25px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
}

.steps-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.3);
}

.steps-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.step-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.step-text {
  font-size: 15px;
  color: #4a5568;
  line-height: 1.6;
  padding-top: 4px;
}

/* 帮助按钮区域 */
.help-section {
  text-align: center;
}

.help-btn {
  color: #667eea;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 8px;
}

.help-btn:hover {
  color: #764ba2;
  background: rgba(102, 126, 234, 0.1);
}

/* ==================== 底部备案信息 ==================== */
.footer-section {
  margin-top: auto;
  margin-bottom: 30px;
  animation: fadeIn 0.8s ease-out 0.4s backwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}

.footer-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.3s ease;
}

.footer-item:hover {
  color: rgba(255, 255, 255, 1);
}

.footer-link {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  margin-left: 6px;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;
}

.footer-link:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.15);
  text-decoration: underline;
}

.beian-icon {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  vertical-align: middle;
}

/* ==================== 对话框样式 ==================== */
.browser-dialog,
.scan-dialog,
.test-dialog {
  border-radius: 16px;
}

.dialog-content {
  padding: 20px;
}

.dialog-text {
  font-size: 15px;
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 20px;
}

.dialog-text-highlight {
  font-weight: 600;
  color: #667eea;
}

.dialog-image {
  text-align: center;
  margin: 20px 0;
  padding: 20px;
  background: #f7fafc;
  border-radius: 12px;
}

.dialog-image img {
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dialog-footer {
  text-align: center;
  padding: 10px 20px 20px 20px;
}

.dialog-footer-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
}

/* ==================== 扫码对话框样式 ==================== */
.scan-dialog-content {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 30px;
  padding: 20px;
}

.scan-step {
  text-align: center;
}

.scan-step-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
}

.scan-qrcode {
  padding: 15px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.scan-qrcode img {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  display: block;
}

.scan-instructions {
  flex: 1;
  padding: 20px;
  background: #fff5f5;
  border-left: 4px solid #f56565;
  border-radius: 8px;
}

.instruction-text {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 20px;
}

.highlight-text {
  color: #e53e3e;
  font-weight: 600;
  padding: 0 4px;
}

.bold-text {
  font-weight: 600;
  color: #2d3748;
  padding: 0 4px;
}

.warning-text {
  font-size: 14px;
  color: #c53030;
  line-height: 1.6;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.warning-text i {
  font-size: 16px;
}

.help-link {
  text-align: center;
  margin-top: 15px;
}

/* ==================== 测试登录对话框样式 ==================== */
.test-dialog-content {
  padding: 20px 30px;
}

.login-form {
  padding: 10px 0;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1200px) {
  .content-section {
    flex-direction: column;
    align-items: center;
  }

  .left-panel,
  .right-panel {
    max-width: 100%;
    width: 100%;
  }

  .right-panel {
    flex: 0 0 auto;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 36px;
  }

  .subtitle {
    font-size: 16px;
  }

  .content-section {
    gap: 40px;
  }

  .scan-dialog-content {
    flex-direction: column;
  }

  .scan-instructions {
    width: 100%;
  }

  .footer-content {
    flex-direction: column;
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 28px;
  }

  .subtitle {
    font-size: 14px;
  }

  .login-card {
    margin: 0 -10px;
  }

  .scan-btn {
    font-size: 16px;
    padding: 14px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue